import React from 'react';

import * as hooks from '../../../../hooks';
import { CarouselItem } from '../CarouselItem';

import style from './OverflowSlider.scss';

export const OverflowSlider = () => {
    const topWinners = hooks.useTopWinners();

    return (
        <div className={`${style.topWinners} cms-top-winners-carousel-not-desktop`}>
            {topWinners.map(topWinner =>
                <CarouselItem
                    {...topWinner}
                    key={topWinner.id}
                    className={style.topWinner}
                />
            )}
        </div>
    );
};
